import { useQuery } from "react-query";
import getNoteSkuRepayment from "../services/getNoteSkuRepayment";

function useGetNoteSkuRepayment(
  token: string,
  noteId: string,
  globalFilter: string,
  pagination: any,
  sorting: any[]
) {
  return useQuery(
    ["get-note-repayment", noteId, token, globalFilter, pagination, sorting],
    () =>
      getNoteSkuRepayment({ noteId, token, globalFilter, pagination, sorting }),
    {
      retry: false,
      keepPreviousData: true,
      staleTime: 30_000,
    }
  );
}

export default useGetNoteSkuRepayment;
